import React, { useContext } from 'react';
import ModalContext from './context';

export const useModal = () => {
  const context = useContext(ModalContext);

  if (context === undefined) {
    throw new Error('useModal must be used with a ModalProvider');
  }

  return context;
};
